import React from 'react';
import { Container, LoadingContent, LoadingText, Spinner } from './loading.style';

export const LoadingScreen = ({ loadingText }) => {
  return (
    <Container role="alert" aria-live="assertive">
      <LoadingContent>
        <Spinner
          aria-hidden="true"
          style={{
            borderColor: '#2d99e1',
            borderTop: '1px solid transparent',
            width: '2.55rem',
            height: '2.55rem',
          }}
        />
        <LoadingText>{loadingText}</LoadingText>
      </LoadingContent>
    </Container>
  );
};
